angular.module('myApp.directives')
    .directive('studyMessagesHolder', function () {
        return {
            restrict: 'A',
            scope: true,
            link: function (scope, element, attrs) {
            },
            controller: function ($scope, $element, $attrs, $transclude, messagesHolder) {
                try {
                    var messages = JSON.parse($attrs.studyMessagesHolder);
                    messagesHolder.setMessages(messages);
                } catch (e) {
                    console.log(e);
                }
            }
        }
    });